
/*

*/

import React, { useState } from 'react';
import { usePopper } from 'react-popper';

import StyledCheckbox from "./StyledCheckbox";

const defaultDisplayColumns = 4;

/*
PROPS:
    - name
    - selected
    - options
    - dataColumns
    - onChange()
    - hasAllOption: T/F for whether to add an additional "ALL" option
    - onDone()
    - onOpen()
    - doNotShow: T/F

    - displayField

    - selctionMatchFunction

    - selectedDisplayColumns
*/

const MultiSelect = (props) => {
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement);

    const [show, setShow] = useState(false);

    const defaultDisplayStyle = {
        display: "flex"
    };

    const checkToggle = (val) => {
        let selected = [];

        console.log("CHECKED", val);
        console.log("EXISTED SELECTED", props.selected);

        if(val === "ALL"){
            if(props.selected === "ALL"){
                selected = [];
            }
            else{
                selected = "ALL";
            }
        }
        else{
            if(props.selected === "ALL"){
                selected = [val];
            }
            else{
                let matchFound = false;

                selected = props.selected.filter((v) => {
                    console.log("VALUES", val, typeof val, v, typeof v, v==val);
                    console.log("MATCH FUNCTION?", props.selctionMatchFunction);
                    if(props.selctionMatchFunction){
                        const result = props.selctionMatchFunction(v, val);
                        matchFound |= result;
                        return !result;
                    }
                    // return v !== val;
                    matchFound |= (v == val);
                    return v !== val;
                });

                console.log("MATCH?", matchFound);

                if(!matchFound){
                    selected = [...props.selected, val].sort();
                }
            }
        }

        props.onChange({target: {name: props.name, value: selected}});
    }

    const buttonClick = () => {
        if(show && props.onDone && typeof props.onDone === "function"){
            props.onDone();
        }
        else if(!show && props.onOpen && typeof props.onOpen === "function"){
            props.onOpen();
        }
        setShow(!show); 
    }

    const options = props.hasAllOption ? ["ALL", ...props.options] : props.options;

    return (
        <>
        <div style={defaultDisplayStyle}>
        {
            props.selected && !props.doNotShow
            && <>
            {
                props.selected === "ALL"
                ? <span className="multiselected">ALL</span>
                : <span style={{
                    display: "grid",
                    gridTemplateColumns: "1fr ".repeat(props.selectedDisplayColumns ? props.selectedDisplayColumns: defaultDisplayColumns)
                }}>
                    {
                        props.selected.map((v, index) => {
                            const display = props.displayField ? v[props.displayField] : v;
                            return <span className="multiselected" key={index}>{display}</span>
                        })
                    }
                </span>
            }
            </>
        }
        {
            options && options.length > 0 && !(options.length === 1 && options[0] === "ALL")
            ? (
                <button type="button" className={show ? "option option-on" : "option"} style={{display: "inline-block", maxHeight:"38px"}} ref={setReferenceElement} onClick={buttonClick}>
                {
                    show ? "Done" : props.label ? props.label : "Select"
                }
            </button>
            )
            : "..."
        }
        </div>

        {
            show && options && options.length
            ? <div ref={setPopperElement} style={{...styles.popper, zIndex:10}} {...attributes.popper}>
                <div style={{
                    marginTop: "4px",
                    padding: "4px",
                    border: "1px solid var(--light-gray)",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr ".repeat(props.dataColumns)
                    }}>
                        {
                            options.map((val, index) => {
                                let selected = false;

                                const display = props.displayField ? val[props.displayField] : val;
                                
                                if(val === "ALL" && props.selected === "ALL"){
                                    selected = true;
                                }
                                else if(props.selected !== "ALL"){
                                    console.log("PROPS SELECTED", props.selected);
                                    for(let i = 0; i < props.selected.length; i++){
                                        const v = props.selected[i];
                                        if(props.selctionMatchFunction && typeof props.selctionMatchFunction === "function"
                                            && props.selctionMatchFunction(v, val)
                                        ){
                                            selected = true;
                                            break;
                                        }
                                        else if(v === val){
                                            selected = true;
                                            break;
                                        }
                                    }
                                }

                                return <span key={index}
                                        style={{
                                            margin:"6px"
                                        }}
                                    >
                                    <StyledCheckbox 
                                        checked={selected}
                                        onChange={() => {
                                            checkToggle(val);
                                        }}
                                        label={display}
                                    />
                                </span>
                            })
                        }
                    </div>
                </div>
            </div>
            : null
        }
        </>
    );
};

export default MultiSelect;
